export default __webpack_public_path__ + "static/media/icon-144x144.8c0e12fa.png";